import React from "react";
import Spinner from "../Spinner";
import { IoStar } from "react-icons/io5";

const DoctorList = ({ doctorList, loading }) => {
    if (loading) {
        return <div className="spinner"><Spinner /></div>;
    }

    const renderStars = (count) => {
        return Array.from({ length: count }, (_, i) => (
            <span key={i} className="star"><IoStar/></span>
        ));
    };

    return (
        <div className="group-list">
            {doctorList?.map((doctor, index) => (
                <div className="group-item" key={index}>
                    <img src={doctor?.pictureUrl || '/user-avater.png'} alt={doctor?.username} className="group-image" />
                    <div className="group-info">
                        <p className="group-title">{doctor?.username}</p>
                        <p className="group-meta">{doctor?.email}</p>
                        <p className="group-meta">{doctor?.designation}</p>
                        <p className="group-meta">{doctor?.location}</p>
                        <p className="group-meta">{renderStars( 2)}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DoctorList;
